import React, { useContext } from 'react';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import ListHostsForAUser from '@website/components/hosts/dashboard/usersHost/ListHostsForAUser';
import LoadingPage from '../../../components/utilities/LoadingPage';
import { Store } from '../../../Store';

export function UserHostsDashboard() {
  const { state } = useContext(Store);

  // show spinner when state is not authenticated
  // this ensure that the user id from state is definitely defined before
  // loading the ListHostsForAUser component which needs it
  if (!state.isAuthenticated) {
    return <LoadingPage />;
  }

  return <ListHostsForAUser userID={state.user.id} />;
}

export default function DashboardPage() {
  return (
    <>
      <RequiresAuth>
        <UserHostsDashboard />
      </RequiresAuth>
    </>
  );
}
